import { render, staticRenderFns } from "./details.vue?vue&type=template&id=37162750&scoped=true"
import script from "./details.vue?vue&type=script&lang=en"
export * from "./details.vue?vue&type=script&lang=en"
import style0 from "./details.vue?vue&type=style&index=0&id=37162750&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37162750",
  null
  
)

export default component.exports